import React from "react";
import { Link } from "react-router-dom";
import { FaFacebook, FaTwitter, FaLinkedin,FaInstagram  } from "react-icons/fa";
import "./Products.css";

const Products = () => {
  return (
    <div className="products">
      <section className="hero-section">
        <div className="hero-overlay"></div>
        <video autoPlay muted loop playsInline className="hero-video">
          <source
            src="https://res.cloudinary.com/dy8shu8ss/video/upload/v1740998404/DALLE-2025-03-03-150044-A-visual_1_dih57b.mp4"
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
        <div className="hero-content">
          <h1>Innovative Solutions. Limitless Possibilities.</h1>
          <p>Harness the power of AI and cutting-edge development to transform the future.</p>
        </div>
      </section>

      <h1 className="products-heading">Our Products</h1>

      {/* First Product Section */}
      <div className="product-section">
        <div className="video-container">
          <iframe
            src="https://www.youtube.com/embed/mJeNghZXtMo"
            title="AI Explained"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
        <div className="product-content">
          <h2 className="product-title">Artificial Intelligence</h2>
          <p className="product-text">
            Explore the future with our AI-driven solutions, designed to revolutionize industries.
            From machine learning models to intelligent automation, we create innovative
            technologies that enhance efficiency and decision-making.
          </p>
        </div>
      </div>

      {/* Second Product Section */}
      <div className="product-section reverse">
        <div className="video-container">
          <iframe
            src="https://www.youtube.com/embed/INigK6QdbyA"
            title="Android Development Tutorial"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
        <div className="product-content">
          <h2 className="product-title">Android Development</h2>
          <p className="product-text">
            Build powerful and user-friendly Android applications with our expert development team.
            Our focus is on delivering high-quality, scalable, and secure apps that meet modern
            user expectations and business needs.
          </p>
        </div>
      </div>

      {/* Footer Section */}
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-section">
            <h3>About Us</h3>
            <p>Vero Disruptors is a leading innovator in data-driven solutions, providing cutting-edge services to help businesses grow and succeed.</p>
          </div>
          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/products">Products</a></li>
              <li><a href="/services">Services</a></li>
              <li><a href="/careers">Careers</a></li>
              <li><a href="/contactus">Contact Us</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h3>Follow Us</h3>
            <div className="social-links">
              <a href="https://www.facebook.com/share/1AF81Af26p/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <FaFacebook />
              </a>
              
              <a href="https://www.linkedin.com/company/vero-disruptors-pvt-ltd/?originalSubdomain=in" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <FaLinkedin />
              </a>
              
            </div>
            
          </div>
          
        </div>
        <div className="footer-legal-links">
        
        <a href="/contactus">Contact Us</a>
        <a href="/terms">Term Of Use</a>
        <a href="/privacy">Privacy Statement</a>
        <a href="/refund">            Refund Policy
      </a>
        <a href="/about">About Us</a>
      
      </div>
      
        <div className="contactus-footer">
          <p>Copyright © Vero Disruptors {new Date().getFullYear()}. All rights reserved.</p>
        </div>
      </footer>
      
    </div>
  );
};

export default Products;